import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "View PDF", -1)

import { ref } from "vue";

import { EyeIcon } from "@heroicons/vue/24/outline";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";

import DownloadPdf from "@/classes/Cases/Interventions/DownloadPdf";


export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadTelepsychiatry',
  props: {
    intervention: {
        type: [Number,String],
        required: true,
    },
    isNetworkAvailable: {
        type: Boolean,
        default: true
    },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ButtonComponent, {
    size: "large",
    customClass: "bg-green-600 hover:bg-green-700 text-white transition border border-green-600 hover:border-green-700",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(DownloadPdf).generateTelepsychiatryPDFAccess(__props.intervention, __props.isNetworkAvailable)))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(EyeIcon), { class: "w-5 h-5 mr-2 -ml-1 icon" }),
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})